import { gql } from '@apollo/client/core';

export const UPDATE_SITTER_PROFILE = gql`
  mutation UpdateSitterProfile($input: UpdateSitterProfileInput!) {
    updateSitterProfile(input: $input) {
      sitterProfile {
        babysitterProfileVisible
        companionCareProfileVisible
        housekeepingProfileVisible
        nannyProfileVisible
        petCareProfileVisible
      }
    }
  }
`;

export default UPDATE_SITTER_PROFILE;
